const slugBoys = ["boys-en", "boys", "garcon", "jungen"];
const slugGirls = ["girls-en", "girls", "fille", "madchen"];

/**
 * Convert sub gender from other locales to english
 * fille -> girls, garcon -> boys
 */
export function subGenderLocale({ subGender }: { subGender: string }): string {
  const subGenderToLower = (subGender && subGender.toLowerCase()) || "women";
  if (slugBoys.includes(subGenderToLower)) return "boys";
  if (slugGirls.includes(subGenderToLower)) return "girls";
  return subGenderToLower;
}
